import { createGlobalStyle } from 'styled-components'

export const BackgroundGlobalStyles = createGlobalStyle<{ color: string }>`
  :root {
    --base-background-color: ${({ color }) => color};
  }
`
